import { gql } from "@apollo/client";

export const CREATE_CONTRACT = gql`
  mutation CreateContract($input: CreateContractInput!) {
    contractOps {
      create(input: $input) {
        success
        message
        contract {
          id
          code
          type
          status
          fileURL
          startDate
          endDate
          sellerID
          seller {
            id
            fullName
          }
          createdBy {
            id
            fullname
          }
          drafterBy {
            id
            fullname
          }
        }
        existingActiveContract {
          id
          code
          type
          status
          fileURL
          startDate
          endDate
          sellerID
          seller {
            id
            fullName
          }
          createdBy {
            id
            fullname
          }
          drafterBy {
            id
            fullname
          }
        }
      }
    }
  }
`;

export const DISABLE_CONTRACT = gql`
  mutation DisableContract($id: ID!) {
    contractOps {
      disable(id: $id)
    }
  }
`;
